import { CategoriasProjetos, EtapaProjeto } from 'models/projeto';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Container } from '../../../components/Container';
import { CustomButton } from '../../../components/CustomButton';
import { CustomTextField } from '../../../components/CustomTextField';
import { DateMaskedInput } from '../../../components/MaskedInputs';
import NewAutoCompleteField from '../../../components/NewAutoCompleteField/NewAutoCompleteField';
import ProjetoItem from '../../../components/ProjetoItem/ProjetoItem';
import { SearchFiltersContainer } from '../../../components/SearchFiltersContainer';
import UnauthorizedScreen from '../../../components/UnauthorizedScreen/UnauthorizedScreen';
import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
  PROJECT_STATUS_REJEITADO,
} from '../../../library/ProjectStatus';
import { projectFluxControlRoute } from '../../../library/Routes';
import {
  loadCidadesByEstadoId,
  loadCooperativas,
  loadEstados,
} from '../../../store/modules/LogradouroActions';
import {
  clearProjetosPageList,
  loadProjetosPaginados,
} from '../../../store/modules/ProjetoActions';
import { dateIsEmpty, getDataLenght } from '../../../utils/DateUtils';
import { getElementID } from '../../../utils/HTMLUtils';
import { getSearchText } from '../../../utils/SearchUtils';
import { dateIsValid, periodIsValid } from '../../../utils/ValidationUtils';
import { Col } from './../../../components/Col';
import { Row } from './../../../components/Row';
import styles from './Projetos.scss';
import CustomSelect from 'components/CustomSelect';
import { isAuthorizedRequest } from 'utils/httpResponseHandlers';
import {
  EDUCACAO_ENSINO_MEDIO_DOIS,
  EDUCACAO_ENSINO_MEDIO_TRES,
  EDUCACAO_ENSINO_MEDIO_UM,
  EDUCACAO_FUNDAMENTAL_CINCO,
  EDUCACAO_FUNDAMENTAL_DOIS,
  EDUCACAO_FUNDAMENTAL_NOVE,
  EDUCACAO_FUNDAMENTAL_OITO,
  EDUCACAO_FUNDAMENTAL_QUATRO,
  EDUCACAO_FUNDAMENTAL_SEIS,
  EDUCACAO_FUNDAMENTAL_SETE,
  EDUCACAO_FUNDAMENTAL_TRES,
  EDUCACAO_FUNDAMENTAL_UM,
  EDUCACAO_INFANTIL_BEBES,
  EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_MATERNAL,
  EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_PRE_ESCOLA,
} from 'library/ProjectEtapasEnsino';
import {
  PROJECT_FILTER_ASSESSOR_PEDAGOGICO,
  PROJECT_FILTER_INSTITUICAO,
  PROJECT_FILTER_NOME_DO_PROFESSOR,
  PROJECT_FILTER_NOME_DO_PROJETO,
} from 'library/ProjectCategoryFilter';
import SearchTextFieldCustom from 'components/SearchTextField/SearchTextFieldProjectCustom/SearchTextFieldCustom';
import CustomSelectEtapasProjetos from 'components/CustomSelect/CustomSelectEtapasProjetos';
import { debounce } from 'utils/DebounceFilters';
import { AddIcon } from 'assets/icons/AddIcon';
import { ArrowDownwardOutlined } from '@material-ui/icons';
import Loader from 'components/Loader/Loader';

const rootClassName = styles.rootClassName;
const rootElementId = 'projetos-';
export const PROJETOS_FILTER_ID_ESTADO = 'idEstado';
export const PROJETOS_FILTER_NOM_CIDADE = 'nomCidade';
export const PROJETOS_FILTER_DATA_INICIO = 'dataInicio';
export const PROJETOS_FILTER_DATA_FIM = 'dataFim';

const INITIAL_STATE = {
  authorizedRequest: true,
  loadingEtapasEnsino: false,
  searching: true,
  searchingText: '',
  selectedStatus: '',
  active: null,
  selectedCoop: '',
  selectedEtapasEnsino: '',
  allStatus: [],
  allCategory: [],
  searchText: '',
  [PROJETOS_FILTER_ID_ESTADO]: '',
  [PROJETOS_FILTER_NOM_CIDADE]: '',
  [PROJETOS_FILTER_DATA_INICIO]: '',
  [PROJETOS_FILTER_DATA_FIM]: '',
};
class Projetos extends Component {
  isFirstLoad = true;
  constructor(props) {
    super(props);
    const { tipo, search } = this.props.match.params;
    let decodedTipo = this.decodeFromBase64(tipo) || '';
    let decodedSearch = this.decodeFromBase64(search) || '';
    const allCategoryOptions = this.getOptionsForProfile(
      this.props.auth.userData.perfil
    );
    let searchValueSelector = '';
    let localAssessorName = props.assessorName;
    let localProfessorName = props.professorName;
    let localCordenadorName = props.cordenadorName;
    let initialSelectedCategory = CategoriasProjetos.nomeDoProjeto;

    switch (decodedTipo) {
      case '0':
        localAssessorName = decodedSearch;
        searchValueSelector = localAssessorName;
        initialSelectedCategory = CategoriasProjetos.assessorPedagogico;
        break;
      case '1':
        localProfessorName = decodedSearch;
        searchValueSelector = localProfessorName;
        initialSelectedCategory = CategoriasProjetos.professor;
        break;
      case '3':
        localCordenadorName = decodedSearch;
        searchValueSelector = localCordenadorName;
        initialSelectedCategory = CategoriasProjetos.professor;
        break;
      default:
        break;
    }

    this.state = {
      isSuggestionSelected: false,
      searchValueSelector: searchValueSelector,
      searchValue: '',
      resetSearch: '',
      ...INITIAL_STATE,
      selectedCategory: initialSelectedCategory,
      allStatus: [
        {
          id: '',
          name: this.props.languageValues.allStatus,
        },

        {
          id: PROJECT_STATUS_RASCUNHO,
          name: this.props.languageValues.projectStatusRascunho,
        },
        {
          id: PROJECT_STATUS_PENDENTE,
          name: this.props.languageValues.projectStatusPendente,
        },
        {
          id: PROJECT_STATUS_APROVADO,
          name: this.props.languageValues.projectStatusAprovado,
        },
        {
          id: PROJECT_STATUS_REJEITADO,
          name: this.props.languageValues.projectStatusRejeitado,
        },
      ],
      allEtapasEnsino: [
        {
          id: EDUCACAO_INFANTIL_BEBES,
          name: this.props.languageValues.educacaoInfantilBebes,
        },
        {
          id: EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_MATERNAL,
          name: this.props.languageValues
            .educacaoInfantilCriancasBemPequenasMaternal,
        },
        {
          id: EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_PRE_ESCOLA,
          name: this.props.languageValues
            .educacaoInfantilCriancasBemPequenasPreEscola,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_UM,
          name: this.props.languageValues.educacaoFundamentalUm,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_DOIS,
          name: this.props.languageValues.educacaoFundamentalDois,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_TRES,
          name: this.props.languageValues.educacaoFundamentalTres,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_QUATRO,
          name: this.props.languageValues.educacaoFundamentalQuatro,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_CINCO,
          name: this.props.languageValues.educacaoFundamentalCinco,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_SEIS,
          name: this.props.languageValues.educacaoFundamentalSeis,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_SETE,
          name: this.props.languageValues.educacaoFundamentalSete,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_OITO,
          name: this.props.languageValues.educacaoFundamentalOito,
        },
        {
          id: EDUCACAO_FUNDAMENTAL_NOVE,
          name: this.props.languageValues.educacaoFundamentalNove,
        },
        {
          id: EDUCACAO_ENSINO_MEDIO_UM,
          name: this.props.languageValues.educacaoEnsinoMedioUm,
        },
        {
          id: EDUCACAO_ENSINO_MEDIO_DOIS,
          name: this.props.languageValues.educacaoEnsinoMedioDois,
        },
        {
          id: EDUCACAO_ENSINO_MEDIO_TRES,
          name: this.props.languageValues.educacaoEnsinoMedioTres,
        },
      ],
      allCategory: allCategoryOptions,
      activeOptions: [
        {
          label: this.props.languageValues.projectSim,
          value: true
        },
        {
          label: this.props.languageValues.projectNao,
          value: false
        },
        {
          label: this.props.languageValues.projectAmbos,
          value: null
        }
      ]
    };

    this.toSearch = this.toSearch.bind(this);
    this.changeSearchingStatus = this.changeSearchingStatus.bind(this);
    this.toNewSearch = this.toNewSearch.bind(this);
    this.changeActive = this.changeActive.bind(this);

    //Debounce Filters
    this.handleEtapasEnsinoChange = this.handleEtapasEnsinoChange.bind(this);
    this.changeSelectedEtapasEnsino =
      this.changeSelectedEtapasEnsino.bind(this);
    this.debouncedChange = debounce(this.changeSelectedEtapasEnsino, 1000);
  }

  decodeFromBase64(data) {
    try {
      return decodeURIComponent(escape(window.atob(data)));
    } catch (err) {
      return null;
    }
  }

  removeURLParameters() {
    const newURL = '/programaseducacionais/admin/projetos/pufv';
    window.history.pushState({}, '', newURL);
  }

  componentDidMount() {
    this.loadEstados();
    this.removeURLParameters();
    if (this.props.auth.userPermissions.projetos.filters.coop) {
      this.props.loadCooperativas();
    }
    this.toSearch();
  }

  getOptionsForProfile(profile) {
    const baseOptions = [
      {
        id: PROJECT_FILTER_NOME_DO_PROJETO,
        name: this.props.languageValues.ProjectFilterNomeDeProjeto,
      },
    ];

    const extendedOptions = [
      {
        id: PROJECT_FILTER_NOME_DO_PROFESSOR,
        name: this.props.languageValues.ProjectFilterProfessor,
      },
      {
        id: PROJECT_FILTER_INSTITUICAO,
        name: this.props.languageValues.ProjectFilterInstituicao,
      },
    ];

    const assessorOption = [
      {
        id: PROJECT_FILTER_ASSESSOR_PEDAGOGICO,
        name: this.props.languageValues.ProjectFilterAssessorPedagogico,
      },
    ];

    switch (profile) {
      case 'pufv_professor':
        return baseOptions;
      case 'pufv_professor_gestor':
      case 'pufv_coordenador_local':
      case 'pufv_assessor_pedagogico_gestor':
      case 'pufv_assessor_pedagogico':
        return [...baseOptions, ...extendedOptions];
      case 'pufv_cooperativa':
      case 'pufv_central':
      case 'pufv_administrador':
        return [...baseOptions, ...extendedOptions, ...assessorOption];
      default:
        return [];
    }
  }

  changeSearchingStatus(isSearching, moreProps = {}) {
    if (isSearching !== this.isLoading()) {
      this.setState({
        ...this.state,
        searching: isSearching,
        ...moreProps,
      });
    }
  }

  toSearch(text, page, size) {
    const busca = getSearchText(text ? String(text).trim() : '');
    page =
      page ||
      (this.props.projeto.pageList.page < 1
        ? 1
        : this.props.projeto.pageList.page + 1);
    size = size || this.props.projeto.pageSize;
    const filtrarPor = this.state.selectedCategory;
    let filtro = this.state.searchValue || this.state.searchValueSelector || '';
    const dataInicio = this.state[PROJETOS_FILTER_DATA_INICIO];
    const dataFim = this.state[PROJETOS_FILTER_DATA_FIM];
    this.changeSearchingStatus(true, {
      searchingText: String(text).trim(),
    });
    const selectedEtapasEnsino = Array.isArray(this.state.selectedEtapasEnsino)
      ? this.state.selectedEtapasEnsino
      : [this.state.selectedEtapasEnsino];
    const selectedCoop = Array.isArray(this.state.selectedCoop)
      ? this.state.selectedCoop
      : [this.state.selectedCoop];
    const idEstado = Array.isArray(this.state[PROJETOS_FILTER_ID_ESTADO])
      ? this.state[PROJETOS_FILTER_ID_ESTADO]
      : [this.state[PROJETOS_FILTER_ID_ESTADO]];
    const nomCidade = Array.isArray(this.state[PROJETOS_FILTER_NOM_CIDADE])
      ? this.state[PROJETOS_FILTER_NOM_CIDADE]
      : [this.state[PROJETOS_FILTER_NOM_CIDADE]];

    let filters = {
      busca: busca,
      status: this.state.selectedStatus,
      etapasEnsino: selectedEtapasEnsino,
      coop: selectedCoop,
      idEstado: idEstado,
      nomCidade: nomCidade,
      dataInicio: this.allowSendPeriodFilter()
        ? dataInicio
        : this.props.projeto.pageList[PROJETOS_FILTER_DATA_INICIO],
      dataFim: this.allowSendPeriodFilter()
        ? dataFim
        : this.props.projeto.pageList[PROJETOS_FILTER_DATA_FIM],
      filtrarPor: filtrarPor,
      filtro: filtro,
      ativo: this.state.active,
    };
    if (!this.allowSendPeriodFilter() && page === 1) {
      filters[PROJETOS_FILTER_DATA_INICIO] = '';
      filters[PROJETOS_FILTER_DATA_FIM] = '';
    }
    this.setState({
      [PROJETOS_FILTER_DATA_INICIO]: filters[PROJETOS_FILTER_DATA_INICIO],
      [PROJETOS_FILTER_DATA_FIM]: filters[PROJETOS_FILTER_DATA_FIM],
    });

    this.props.loadProjetosPaginados(
      filters,
      page,
      size,
      () => {
        this.changeSearchingStatus(false);
        this.isFirstLoad = false;
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeSearchingStatus(false);
          this.isFirstLoad = false;
          SnackbarUtils.enqueueSnackbar({
            message:
              error && error.response && error.response.statusText
                ? error.response.statusText
                : this.props.languageValues.errorSearchingProjetos,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeSearchingStatus(false, {
            authorizedRequest: false,
          });
        }
      },
      true
    );
  }

  // FUNÇÃO PARA IDENTIFICAR SE OS FILTROS ESTÃO VAZIOS E ASSIM REINICIAR COM STATUS
  componentDidUpdate(prevProps, prevState) {
    const filterFields = [PROJETOS_FILTER_ID_ESTADO];

    const filterChanged = filterFields.some((field) => {
      return prevState[field] !== this.state[field];
    });
    if (filterChanged && !this.state.statusChanged) {
      const areAllFiltersEmpty = filterFields.every((field) => {
        return this.state[field].length === 0;
      });
      if (areAllFiltersEmpty) {
        this.toSearch(this.state.searchingText, '');
      } else {
        this.toSearch(this.state.searchingText, this.state.selectedStatus);
      }
    }
  }

  refreshList = () => {
    const page = this.props.projeto.pageList.page;
    this.props.clearProjetosPageList();
    this.toSearch(this.state.searchingText, page);
  };

  componentWillUnmount() {
    this.props.clearProjetosPageList();
    this.isFirstLoad = true;
  }

  showLoadMore() {
    if (this.isLoading()) {
      return false;
    }
    if (
      this.props.projeto.pageList.totalElements >
      this.props.projeto.pageList.elements.length
    ) {
      return true;
    }
    return false;
  }

  getPreloader = () => {
    return (
      <Row>
        <Col
          cols={[12, 12, 12, 12, 12]}
          className='load-more-container'
        >
          <div className='preloader'>
            <Loader dotWidth='12px' dotHeight='12px' dotMargin='0,3' />
          </div>
        </Col>
      </Row>
    );
  };

  toLoadMore() {
    const nextPage = this.props.projeto.pageList.page + 1;
    this.toSearch(this.props.projeto.pageList.busca, nextPage);
  }

  getLegendResults() {
    let legend = '';
    const text = this.state.searchingText;
    if (this.props.projeto.pageList.totalElements === 1) {
      legend =
        text.length === 0
          ? this.props.languageValues.legendProjetosResultSingularEmpty
          : this.props.languageValues.legendProjetosResultSingular;
    } else {
      legend =
        text.length === 0
          ? this.props.languageValues.legendProjetosResultPluralEmpty
          : this.props.languageValues.legendProjetosResultPlural;
    }
    return (
      legend
        /* eslint-disable-next-line */
        .split('${1}')
        .join(this.props.projeto.pageList.elements.length)
        /* eslint-disable-next-line */
        .split('${2}')
        .join(this.props.projeto.pageList.totalElements)
        /* eslint-disable-next-line */
        .split('${3}')
        .join(this.state.searchingText)
    );
  }

  changeSelectedCategory(newCategory) {
    this.setState(
      {
        selectedCategory: newCategory,
        searchingText: '',
        searchValueSelector: '',
        searchValue: '',
      },
      () => {
        this.props.clearProjetosPageList();
        this.toSearch(this.state.searchingText, 1);
      }
    );
  }

  handleValueChange = (value) => {
    this.setState({ searchValue: value, isSuggestionSelected: true }, () => {
      if (this.state.isSuggestionSelected) {
        this.toSearch(this.state.searchValue, 1);
      }
    });
  };

  changeSelectedStatus(newStatus) {
    if (this.state.selectedStatus !== newStatus) {
      this.props.clearProjetosPageList();
      this.setState(
        {
          selectedStatus: newStatus,
        },
        () => {
          this.toSearch(this.props.projeto.pageList.busca);
        }
      );
    }
  }

  changeActive(active) {
    if (this.state.active !== active) {
      this.props.clearProjetosPageList();
      this.setState(
        {
          active: active,
        },
        () => {
          this.toSearch(this.props.projeto.pageList.busca);
        }
      );
    }
  }

  handleEtapasEnsinoChange(value) {
    this.setState({ loadingEtapasEnsino: true });
    this.debouncedChange(value);
  }

  changeSelectedEtapasEnsino(newEtapasEnsino) {
    this.props.clearProjetosPageList();
    this.setState(
      {
        selectedEtapasEnsino: newEtapasEnsino,
        loadingEtapasEnsino: false,
      },
      () => {
        this.toSearch(this.props.projeto.pageList.busca);
      }
    );
  }

  changeSelectedCoop(newCoop) {
    this.props.clearProjetosPageList();
    this.setState(
      {
        selectedCoop: newCoop,
      },
      () => {
        this.toSearch(this.props.projeto.pageList.busca);
      }
    );
  }

  changeSelectedEstado(idEstado) {
    if (!idEstado) {
      this.props.clearProjetosPageList();
      this.setState({
        [PROJETOS_FILTER_ID_ESTADO]: '',
        [PROJETOS_FILTER_NOM_CIDADE]: '',
      });
      return;
    }
    this.props.clearProjetosPageList();
    this.setState(
      {
        [PROJETOS_FILTER_ID_ESTADO]: idEstado,
        [PROJETOS_FILTER_NOM_CIDADE]: '',
      },
      () => {
        if (Array.isArray(idEstado) && idEstado.length === 1) {
          this.loadCidades();
        }
      }
    );
  }

  handleEstadosChange = (value) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      this.changeSelectedEstado('');
      this.setState({
        [PROJETOS_FILTER_NOM_CIDADE]: '',
      });
      return;
    }
    this.changeSelectedEstado(value);
    this.setState({
      [PROJETOS_FILTER_NOM_CIDADE]: '',
    });
  };

  changeSelectedCidade(nomCidade) {
    this.props.clearProjetosPageList();
    this.setState(
      {
        [PROJETOS_FILTER_NOM_CIDADE]: nomCidade,
      },
      () => {
        this.toSearch(this.props.projeto.pageList.busca);
      }
    );
  }

  periodIsValid = (value1, value2, validationError) => {
    const validation = periodIsValid(value1, value2, validationError);
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  dataInicioIsValid = () => {
    const validationErrorMessage =
      this.props.languageValues.validations.relatorioProjectInicialPeriod
        .validation;
    const validation = dateIsValid(
      this.state[PROJETOS_FILTER_DATA_INICIO],
      validationErrorMessage
    );
    if (
      dateIsEmpty(this.state[PROJETOS_FILTER_DATA_INICIO]) &&
      !dateIsEmpty(this.state[PROJETOS_FILTER_DATA_FIM])
    ) {
      return {
        status: false,
        error:
          this.props.languageValues.validations.relatorioProjectInicialPeriod
            .required,
      };
    }
    if (getDataLenght(this.state[PROJETOS_FILTER_DATA_INICIO]) === 8) {
      if (!validation.status) {
        return validation;
      }
    }
    return {
      status: true,
    };
  };

  dataFimIsValid = () => {
    const validationErrorMessage =
      this.props.languageValues.validations.relatorioProjectInicialPeriod
        .validation;
    const validation = dateIsValid(
      this.state[PROJETOS_FILTER_DATA_FIM],
      validationErrorMessage
    );
    if (
      dateIsEmpty(this.state[PROJETOS_FILTER_DATA_FIM]) &&
      !dateIsEmpty(this.state[PROJETOS_FILTER_DATA_INICIO])
    ) {
      return {
        status: false,
        error:
          this.props.languageValues.validations.relatorioProjectFinalPeriod
            .required,
      };
    }
    if (getDataLenght(this.state[PROJETOS_FILTER_DATA_FIM]) === 8) {
      if (!validation.status) {
        return validation;
      }
    }
    if (
      !dateIsEmpty(this.state[PROJETOS_FILTER_DATA_INICIO]) &&
      getDataLenght(this.state[PROJETOS_FILTER_DATA_FIM]) === 8
    ) {
      const periodValidation = this.periodIsValid(
        this.state[PROJETOS_FILTER_DATA_INICIO],
        this.state[PROJETOS_FILTER_DATA_FIM],
        validationErrorMessage
      );
      if (!periodValidation.status) {
        return periodValidation;
      }
    }
    return {
      status: true,
    };
  };

  allowSendPeriodFilter = () => {
    if (
      (dateIsEmpty(this.state[PROJETOS_FILTER_DATA_INICIO]) &&
        dateIsEmpty(this.state[PROJETOS_FILTER_DATA_FIM])) ||
      (this.dataInicioIsValid() &&
        this.dataFimIsValid() &&
        this.periodIsValid(
          this.state[PROJETOS_FILTER_DATA_INICIO],
          this.state[PROJETOS_FILTER_DATA_FIM]
        ).status)
    ) {
      if (
        this.state[PROJETOS_FILTER_DATA_INICIO] !==
        this.props.projeto.pageList[PROJETOS_FILTER_DATA_INICIO] ||
        this.state[PROJETOS_FILTER_DATA_FIM] !==
        this.props.projeto.pageList[PROJETOS_FILTER_DATA_FIM]
      ) {
        return true;
      }
    }
    return false;
  };

  changeDataInicio = (dataInicio) => {
    const newDataInicio = dateIsEmpty(dataInicio) ? '' : dataInicio;
    const newDataFim = this.state[PROJETOS_FILTER_DATA_FIM];
    this.changeSelectedPeriodo(newDataInicio, newDataFim);
  };

  changeDataFim = (dataFim) => {
    const newDataInicio = this.state[PROJETOS_FILTER_DATA_INICIO];
    const newDataFim = dateIsEmpty(dataFim) ? '' : dataFim;
    this.changeSelectedPeriodo(newDataInicio, newDataFim);
  };

  changeSelectedPeriodo = (dataInicio, dataFim) => {
    this.setState(
      {
        [PROJETOS_FILTER_DATA_INICIO]: dataInicio,
        [PROJETOS_FILTER_DATA_FIM]: dataFim,
      },
      () => {
        if (this.allowSendPeriodFilter()) {
          this.props.clearProjetosPageList();
          this.toSearch(this.props.projeto.pageList.busca, 1);
        }
      }
    );
  };

  toNewSearch(newText) {
    this.props.clearProjetosPageList();
    this.setState(
      {
        searchingText: newText,
        [PROJETOS_FILTER_NOM_CIDADE]: '',
        selectedCategory: '',
      },
      () => {
        this.toSearch(newText, 1);
      }
    );
  }

  handleChange(text) {
    this.setState({
      selectedCategory: '',
      searchingText: text,
    });
  }

  getAllCoops() {
    if (
      this.props.logradouro.cooperativas &&
      this.props.logradouro.cooperativas.length > 0
    ) {
      return [...this.props.logradouro.cooperativas];
    }
    return [];
  }

  getUFByIdEstado = (idEstado) => {
    const estados = this.props.logradouro.estados.filter((estado) => {
      if (estado.id === idEstado) {
        return true;
      }
      return false;
    });
    if (estados && estados.length > 0) {
      return estados[0].sigla;
    }
    return '';
  };

  onLoadedEstados = () => {
    this.loadCidades();
  };

  loadEstados = () => {
    this.props.loadEstados(this.onLoadedEstados);
  };

  loadCidades = () => {
    const idEstado = this.state[PROJETOS_FILTER_ID_ESTADO];
    if (!idEstado) {
      this.setState({
        [PROJETOS_FILTER_NOM_CIDADE]: '',
      });
    } else {
      let uf = this.getUFByIdEstado(idEstado).toLowerCase();
      this.props.loadCidadesByEstadoId(idEstado, uf);
    }
  };

  getEstados = () => {
    const estados = this.props.logradouro.estados;
    if (estados.length > 0) {
      return [...this.props.logradouro.estados];
    }
    return [];
  };

  estadosIsLoading = () => {
    return this.props.logradouro.loadingEstados;
  };

  getCidades = () => {
    const uf = this.getUFByIdEstado(
      this.state[PROJETOS_FILTER_ID_ESTADO]
    ).toLowerCase();
    const cidades = this.props.logradouro.cidades[uf] || [];
    if (cidades.length > 0) {
      return [...this.props.logradouro.cidades[uf]];
    }
    return [];
  };

  cidadesIsLoading = () => {
    return this.props.logradouro.loadingCidades;
  };

  cidadesIsDisabled = () => {
    return (
      this.cidadesIsLoading() ||
      this.state[PROJETOS_FILTER_ID_ESTADO] ===
      INITIAL_STATE[PROJETOS_FILTER_ID_ESTADO]
    );
  };

  isLoading = () => {
    return this.props.projeto.loadingRemoveProjeto || this.state.searching
      ? true
      : false;
  };

  setSearchStateNewTab = (newVal) => {
    this.setState({ searchValueSelector: newVal });
  };

  render() {
    const isIdEstadoEmpty = !this.state[PROJETOS_FILTER_ID_ESTADO];
    const isMultipleStatesSelected =
      Array.isArray(this.state[PROJETOS_FILTER_ID_ESTADO]) &&
      this.state[PROJETOS_FILTER_ID_ESTADO].length > 1;

    return this.state.authorizedRequest &&
      this.props.auth.userPermissions.projetos.list ? (
      <Container
        className={rootClassName + '-container container-fluid'}
        noPadding
      >
        <div className='container-fluid'>
          <Row className={rootClassName + '-header'}>
            {this.props.auth.userPermissions.projetos.register ? (
              <Col cols={[12, 12, 4, 3, 3]}>
                <CustomButton
                  theme='pufvYellow'
                  className={rootClassName + '-create-button'}
                  label={this.props.languageValues.newProjetoButton}
                  rightIcon={<AddIcon />}
                  onClick={() => {
                    this.props.history.push(
                      projectFluxControlRoute.getURLWithParams({
                        step: EtapaProjeto.infosIniciais,
                      })
                    );
                  }}
                />
              </Col>
            ) : null}

            <Col
              style={{ marginLeft: 'auto' }}
              cols={
                this.props.auth.userPermissions.projetos.register
                  ? [12, 12, 4, 4, 3]
                  : [12, 12, 12, 12, 12]
              }
            >
              <NewAutoCompleteField
                className={'filter_category'}
                inputClassName={'filter_category_input'}
                options={this.state.allCategory.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                })}
                value={this.state.selectedCategory}
                onChange={(value) => {
                  if (value && value.value !== this.state.selectedCategory) {
                    this.changeSelectedCategory(value.value);
                  } else {
                    this.setState({ selectedCategory: 0 });
                  }
                }}
              />
            </Col>
            <Col
              cols={
                this.props.auth.userPermissions.projetos.register
                  ? [12, 12, 4, 5, 4]
                  : [12, 12, 12, 12, 12]
              }
            >
              <SearchTextFieldCustom
                placeholder={this.props.languageValues.serchProjetoPlaceholder}
                disabled={this.isLoading()}
                onSearchClick={this.newText}
                selectedCategory={Number(this.state.selectedCategory)}
                onValueChange={this.handleValueChange}
                onClick={() => this.newText(this.state.searchText)}
                clearProjects={this.refreshList}
                resetPage={() => this.props.clearProjetosPageList()}
                currentPage={this.props.projeto.pageList.page}
                searchValueSelector={this.state.searchValueSelector}
                updateStatePropsNewTab={this.setSearchStateNewTab}
              />
            </Col>
          </Row>

          <SearchFiltersContainer className='margin-bottom-30'>
            <Row>
              {this.props.auth.userPermissions.projetos.filters.situacao ? (
                <Col
                  cols={[12, 12, 6, 3, 3]}
                >
                  <NewAutoCompleteField
                    label={this.props.languageValues.projectStatus}
                    className={rootClassName + '-status-filter'}
                    inputClassName={rootClassName + '-status-input-filter'}
                    options={this.state.allStatus.map((item) => {
                      return {
                        label: item.name,
                        value: item.id,
                      };
                    })}
                    value={this.state.selectedStatus}
                    onChange={(value) => {
                      if (value && value.value !== this.state.selectedStatus) {
                        this.changeSelectedStatus(value.value);
                      } else {
                        this.changeSelectedStatus(this.state.allStatus[0].id);
                      }
                    }}
                  />
                </Col>
              ) : null}

              <Col
                cols={[12, 12, 6, 3, 3]}
              >
                <NewAutoCompleteField
                  label={this.props.languageValues.projectAtivo}
                  className={rootClassName + '-ativo-filter'}
                  inputClassName={rootClassName + '-ativo-input-filter'}
                  options={this.state.activeOptions}
                  value={this.state.active}
                  onChange={(value) => {
                    if (value && value.value !== this.state.active) {
                      this.changeActive(value.value);
                    } else {
                      this.changeActive(null);
                    }
                  }}
                />
              </Col>

              {this.props.auth.userPermissions.projetos.filters.coop ? (
                <Col
                  cols={
                    this.props.auth.userPermissions.projetos.filters.situacao
                      ? [12, 12, 6, 6, 6]
                      : [12, 12, 12, 12, 12]
                  }
                >
                  <CustomSelect
                    placeholder='Selecione uma ou mais cooperativas'
                    label={this.props.languageValues.cooperativasFilterLabel}
                    className={rootClassName + '-coop-filter'}
                    inputClassName={rootClassName + '-coop-input-filter'}
                    disabled={this.props.logradouro.loadingCooperativas}
                    options={this.getAllCoops().map((coop) => {
                      return {
                        label: coop.nome,
                        value: coop.codigo,
                      };
                    })}
                    value={this.state.selectedCoop}
                    onChange={(value) => {
                      this.changeSelectedCoop(value);
                    }}
                    loading={this.props.logradouro.loadingCooperativas}
                    loadingMessage={
                      this.props.languageValues.loadingCooperativas
                    }
                    multiple={true}
                  />
                </Col>
              ) : null}

              <Col cols={[12, 12, 6, 6, 6]}>
                <CustomSelect
                  placeholder='Selecione um ou mais estados'
                  label={this.props.languageValues.contratoEstados}
                  className={rootClassName + '-estados-filter'}
                  inputClassName={rootClassName + '-estados-input-filter'}
                  options={this.getEstados().map((item) => {
                    return {
                      label: item.nome,
                      value: item.id,
                    };
                  })}
                  value={this.state[PROJETOS_FILTER_ID_ESTADO]}
                  onChange={this.handleEstadosChange}
                  disabled={this.estadosIsLoading()}
                  loading={this.estadosIsLoading()}
                  multiple={true}
                />
              </Col>

              <Col cols={[12, 12, 6, 6, 6]}>
                <CustomSelect
                  placeholder='Selecione uma ou mais cidades'
                  label={this.props.languageValues.contratoCidades}
                  className={rootClassName + '-cidades-filter'}
                  inputClassName={rootClassName + '-cidades-input-filter'}
                  options={this.getCidades().map((cidade) => {
                    return {
                      label: cidade.nome,
                      value: cidade.nome,
                    };
                  })}
                  value={this.state[PROJETOS_FILTER_NOM_CIDADE]}
                  onChange={(value) => {
                    this.changeSelectedCidade(value);
                  }}
                  disabled={
                    this.cidadesIsDisabled() ||
                    isIdEstadoEmpty ||
                    isMultipleStatesSelected
                  }
                  loading={this.cidadesIsLoading()}
                  loadingMessage={this.props.languageValues.loadingCidades}
                  multiple={true}
                  isClearable
                />
              </Col>

              <Col cols={[12, 12, 6, 6, 6]}>
                <CustomSelectEtapasProjetos
                  placeholder='Selecione uma ou mais etapas de ensino'
                  label='Etapas de Ensino'
                  options={this.state.allEtapasEnsino.map((item) => ({
                    label: item.name,
                    value: item.id,
                  }))}
                  value={this.state.selectedEtapasEnsino}
                  onChange={this.handleEtapasEnsinoChange}
                  multiple={true}
                  isLoading={this.state.loadingEtapasEnsino}
                  isDisabled={this.state.loadingEtapasEnsino}
                />
              </Col>

              <Col cols={[12, 12, 12, 6, 6]} style={{ padding: '0px' }}>
                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomTextField
                      id={getElementID(rootElementId, 'periodo-inicial')}
                      label={this.props.languageValues.periodoInicial}
                      value={this.state[PROJETOS_FILTER_DATA_INICIO]}
                      onChange={(event) => {
                        this.changeDataInicio(event.target.value);
                      }}
                      onBlur={() => {
                        this.setState({ periodoInicialChanged: true });
                      }}
                      helperText={
                        !this.dataInicioIsValid().status
                          ? this.dataInicioIsValid().error
                          : ''
                      }
                      error={!this.dataInicioIsValid().status}
                      InputProps={{
                        inputComponent: DateMaskedInput,
                      }}
                    />
                  </Col>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomTextField
                      id={getElementID(rootElementId, 'periodo-final')}
                      className='periodo-final'
                      label={this.props.languageValues.periodoFinal}
                      value={this.state[PROJETOS_FILTER_DATA_FIM]}
                      onChange={(event) => {
                        this.changeDataFim(event.target.value);
                      }}
                      onBlur={() => {
                        this.setState({ periodoFinalChanged: true });
                      }}
                      helperText={
                        !this.dataFimIsValid().status
                          ? this.dataFimIsValid().error
                          : ''
                      }
                      error={!this.dataFimIsValid().status}
                      InputProps={{
                        inputComponent: DateMaskedInput,
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </SearchFiltersContainer>
          {!this.isLoading() ? (
            <Row>
              <Col cols={[12, 12, 12, 12, 12]}>{this.getLegendResults()}</Col>
            </Row>
          ) : (
            ''
          )}
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={rootClassName + '-list-items'}
            >
              {this.props.projeto.pageList.elements.map((projeto, index) => {
                return (
                  <ProjetoItem
                    projeto={projeto}
                    refreshList={this.refreshList}
                    key={index}
                  />
                );
              })}
            </Col>
          </Row>
          {this.showLoadMore() ? (
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + '-load-more-container'}
              >
                <CustomButton
                  theme='pufvYellow'
                  label={this.props.languageValues.loadMoreProjetoButton}
                  onClick={() => this.toLoadMore()}
                  rightIcon={<ArrowDownwardOutlined />}
                />
              </Col>
            </Row>
          ) : (
            ''
          )}
          {this.state.searching ? this.getPreloader() : ''}
        </div>
      </Container>
    ) : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  projeto: state.projeto,
  languageValues: state.languages.languageValues,
  logradouro: state.logradouro,
  auth: state.auth,
  assessorName: state.assessores.assessorName,
  professorName: state.professores.professorName,
  cordenadorName: state.coordenadores.cordenadorName,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearProjetosPageList,
      loadProjetosPaginados,
      loadCooperativas,
      loadEstados,
      loadCidadesByEstadoId,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Projetos));
